import React, { FC, useEffect } from 'react';
import { FilterItem, FilterType } from './FilterItem';

type Props = {
  filters: Array<FilterType>;
  onFiltersUpdate?: Function;
};

export const FiltersList: FC<Props> = ({ filters, onFiltersUpdate }) => {
  useEffect(() => {
    if (onFiltersUpdate) {
      onFiltersUpdate();
    }
  }, [filters.length]);

  if (!filters.length) {
    return null;
  }

  return (
    <>
      {filters.map((filter) => (
        <FilterItem
          key={filter.labelFull || filter.label || filter.title}
          filter={filter}
        />
      ))}
    </>
  );
};
